export default __webpack_public_path__ + "static/media/bg_enabled.cf6a9f88.svg";